import React, {Component} from 'react';
import QrReader from 'react-qr-reader';
import AppButton from './AppButton';
import '../style/qrScannerShortcode.scss';
import {authClient} from "../tools/apitools";
import {siteContext} from "../tools/toolbox";

export default class QrScannerShortcode extends Component {
  constructor(props) {
    super(props);

    this.state = {
      qrOpen: true,
      shortcode: "",
      errorMessage: null,
      scanned: false,
      sellerData: null,
      loadingSellerData: false,
    }
  }

  extractShortcodeFromData = (data) => {
    const regex = /\/transactions\/([a-zA-Z0-9]{6})/;
    return data.match(regex)?.[1];
  }

  handleScan = data => {
    console.log("Message " + data);
    if (!data)
      return;

    const shortcode = this.extractShortcodeFromData(data);

    if (!shortcode) {
      this.setState({errorMessage: "QR code invalide"});
      return;
    }

    this.fetchSellerData(shortcode);

    this.setState({
      shortcode,
      errorMessage: null,
      qrOpen: false,
      scanned: true,
    });
  }

  handleError = err => {
    console.error(err)
    this.setState({errorMessage: "Impossible de scanner le QR code"});
  }

  fetchSellerData = async (shortcode) => {
    this.setState({loadingSellerData: true})

    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    headers.append("CIBLER_AUTH", siteContext().clientToken);

    try {
      authClient(
        `api/public/seller/data/${shortcode}`,
        { headers: headers },
        (res) => {
          this.setState({
            sellerData: res,
            loadingSellerData: false
          })
        },
        (e) => {
          this.setState({
            loadingSellerData: false,
            errorMessage: "Erreur lors de la récupération des données du vendeur"
          })
        }
      );
    } catch (err) {
      console.error(err);
      this.setState({
        loadingSellerData: false,
        errorMessage: "Erreur lors de la récupération des données du vendeur"
      });
    }
  }

  renderSeller = () => {
    const {sellerData, loadingSellerData} = this.state;

    if (loadingSellerData) {
      return (
        <div className="qrScannerShortcode__seller">
          <div className="qrScannerShortcode__seller__title">
            Chargement...
          </div>
        </div>
      )
    }

    if (!sellerData) {

    }

    const sellerImage = sellerData.data?.find(data => data.key === 'store_image')?.value ||
      sellerData.data?.find(data => data.key === 'store_image_2')?.value ||
      sellerData.data?.find(data => data.key === 'store_image_3')?.value;
    const sellerZipCode = sellerData.data?.find(data => data.key === 'zipcode')?.value;
    const sellerCity = sellerData.data?.find(data => data.key === 'city')?.value;
    const sellerDepartment = sellerData.data?.find(data => data.key === 'department')?.value;

    console.log(sellerImage)
    return (
      <div className="qrScannerShortcode__seller">
        {sellerImage
          ? <img src={sellerImage} alt="Seller image"/>
          : <div className="qrScannerShortcode__seller__image__placeholder" />
        }
        <h2>{sellerData.name.toUpperCase()}</h2>
        {sellerCity && sellerZipCode ? <p>{sellerZipCode}, {sellerCity}</p> : null}
        {!!!sellerCity && sellerDepartment ? <p>{sellerDepartment}</p> : null}
      </div>
    )
  }

  render() {
    const {errorMessage, qrOpen, shortcode} = this.state;
    const {closeQrPopup} = this.props;

    return (
      <div className="QrScannerShortcode">
        <div className="qrScannerShortcode__header">
          <h3>Scannez le QR code</h3>
          <span className="icon icon-close-grey" onClick={closeQrPopup} />
        </div>
        {qrOpen
          ? <div id="qrScannerShortcode" className="qrScannerShortcode__scanner">
              <QrReader
                id="qrReader"
                className="qrScannerShortcode__scanner__qrReader"
                delay={100}
                facingMode="environment"
                onError={this.handleError}
                onScan={this.handleScan}
              />
            </div>
          : this.renderSeller()
        }
        <div className="qrScannerShortcode__feedback">
          {errorMessage
            ? <div className="qrScannerShortcode__feedback__error">
              {errorMessage}
            </div>
            : shortcode
              ? <div className="qrScannerShortcode__feedback__content">
                  <AppButton
                    className="mainButton"
                    onClick={() => this.props.callback(shortcode)}
                  >
                    Valider
                  </AppButton>
                </div>
              : <h3>En attente du scan<span>.</span><span>.</span><span>.</span></h3>
          }
        </div>
      </div>
    )
  }
}
